module.exports = __webpack_public_path__ + "static/media/8.1ea16a73.jpg";